import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentStack16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDocumentStack16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 11a2 2 0 0 1-2 2 2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2 2 2 0 0 1 2-2h3.218a2 2 0 0 1 1.357.53l2.782 2.568A2 2 0 0 1 14 5.568zM5 4H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V8.214H7.071V4zm0-1h2.218a2 2 0 0 1 1.357.53l.496.459V2H6a1 1 0 0 0-1 1m5.399 2.214-.327-.302V2.427l2.606 2.406a1 1 0 0 1 .257.381zm1.073 1A2 2 0 0 1 12 7.568V12a1 1 0 0 0 1-1V6.214zm-.794.62a1 1 0 0 1 .257.38H8.071V4.427z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentStack16);
